import { motion, useReducedMotion } from "framer-motion";
import { cn } from "@/lib/utils";
import { IconBookmark, IconBookmarkFill } from "@/components/icons/Icons";
import { useToggleWatchlist, useWatchlistIds } from "@/hooks/useWatchlist";
import { haptic } from "@/lib/haptics";

export function WatchlistButton({ movieId, variant = "full", className, testId = "watchlist-button" }) {
  const { data: ids } = useWatchlistIds();
  const toggle = useToggleWatchlist();
  const reduce = useReducedMotion();
  const on = Boolean(ids?.includes(movieId));
  const Icon = on ? IconBookmarkFill : IconBookmark;

  const icon = (
    <motion.span key={on ? "on" : "off"} initial={reduce ? false : { scale: 0.6 }} animate={{ scale: 1 }} transition={{ type: "spring", stiffness: 600, damping: 18 }} className="inline-flex">
      <Icon size={variant === "icon" ? 18 : 19} />
    </motion.span>
  );

  return (
    <motion.button
      type="button"
      whileHover={reduce ? undefined : { scale: 1.01 }}
      whileTap={reduce ? undefined : { scale: 0.95 }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        haptic(on ? 8 : 14);
        toggle(movieId, !on);
      }}
      aria-pressed={on}
      aria-label={on ? "Watchlist’dan olib tashlash" : "Watchlist’ga qo‘shish"}
      data-testid={testId}
      data-active={on}
      className={cn(
        "pk-glass inline-flex items-center justify-center font-semibold text-white transition-[background-color] duration-200 hover:bg-white/[.10]",
        variant === "icon" ? "h-10 w-10 rounded-full" : "h-12 gap-2 rounded-[16px] px-5 text-[15.5px]",
        className
      )}
    >
      {icon}
      {variant !== "icon" && <span>{on ? "Saqlangan" : "Watchlist"}</span>}
    </motion.button>
  );
}
